"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var corejs_1 = require("@mesacloud/corejs");
var SPECIAL_TYPES = ["xl", "lg", "md", "sm", "xs"];
var DIRECTIONS = ["top", "right", "bottom", "left"];
var createMarginOrPaddingStyleFromString = function (type, val) {
    var _a;
    if (SPECIAL_TYPES.includes(val)) {
        return [[type + "--" + val], {}];
    }
    else {
        return [[], (_a = {}, _a[type] = val, _a)];
    }
};
var createMarginOrPaddingStyleFromObject = function (type, val) {
    var classNames = [];
    var style = {};
    Object.entries(val).forEach(function (_a) {
        var key = _a[0], mopType = _a[1];
        if (DIRECTIONS.includes(key)) {
            var direction = key;
            if (SPECIAL_TYPES.includes(mopType)) {
                classNames.push(type + "-" + direction + "--" + mopType);
            }
            else {
                style["" + type + corejs_1.capitalize(direction)] = mopType;
            }
        }
    });
    return [classNames, style];
};
var createMarginOrPaddingStyleFromArr = function (type, val) {
    var limitedVal = val.slice(0, DIRECTIONS.length);
    var classNames = [];
    var style = {};
    limitedVal.forEach(function (mopType, i) {
        var direction = DIRECTIONS[i];
        if (SPECIAL_TYPES.includes(mopType)) {
            classNames.push(type + "-" + direction + "--" + mopType);
        }
        else {
            style["" + type + corejs_1.capitalize(direction)] = mopType;
        }
    });
    return [classNames, style];
};
var createMarginOrPaddingStyle = function (type, marginOrPaddingType) {
    switch (typeof marginOrPaddingType) {
        case "string":
            return createMarginOrPaddingStyleFromString(type, marginOrPaddingType);
        case "object":
            if (Array.isArray(marginOrPaddingType)) {
                return createMarginOrPaddingStyleFromArr(type, marginOrPaddingType);
            }
            else if (marginOrPaddingType !== null) {
                return createMarginOrPaddingStyleFromObject(type, marginOrPaddingType);
            }
    }
    return [[], {}];
};
exports.useMarginAndPaddingStyle = function (options) {
    var _a = createMarginOrPaddingStyle("margin", options.margin), marginClassNames = _a[0], marginStyleObj = _a[1];
    var _b = createMarginOrPaddingStyle("padding", options.padding), paddingClassNames = _b[0], paddingStyleObj = _b[1];
    return [marginClassNames.concat(paddingClassNames), __assign(__assign({}, marginStyleObj), paddingStyleObj)];
};
